class OmtMegaMenu extends HTMLElement {
  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[aria-haspopup="true"]'));
    this.triggers.forEach((trigger) => {
      const panel = this.querySelector(`#${trigger.getAttribute('aria-controls')}`);
      if (!panel) return;
      const open = () => this.openPanel(trigger, panel);
      const close = () => this.closePanel(trigger, panel);
      trigger.addEventListener('mouseenter', open);
      trigger.addEventListener('focus', open);
      trigger.addEventListener('click', () => {
        if (trigger.getAttribute('aria-expanded') === 'true') close();
        else open();
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeAll();
    });
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.closeAll();
    });
  }

  openPanel(trigger, panel) {
    this.closeAll();
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  }

  closePanel(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }

  closeAll() {
    this.triggers.forEach((trigger) => {
      const panel = this.querySelector(`#${trigger.getAttribute('aria-controls')}`);
      if (panel) this.closePanel(trigger, panel);
    });
  }
}
customElements.define('omt-mega-menu', OmtMegaMenu);

const header = document.getElementById('omt-header');
const menuToggle = header?.querySelector('[data-omt-menu-toggle]');
menuToggle?.addEventListener('click', () => {
  const isOpen = header.classList.toggle('mobile-open');
  menuToggle.setAttribute('aria-expanded', String(isOpen));
});

header?.querySelectorAll('[data-omt-open]').forEach((button) => {
  button.addEventListener('click', () => {
    document.dispatchEvent(new CustomEvent(`omt:${button.dataset.omtOpen}:open`));
  });
});

document.addEventListener('cart:updated', (event) => {
  const badge = header?.querySelector('[data-omt-cart-count]');
  if (!badge) return;
  const count = event.detail?.itemCount ?? 0;
  badge.textContent = count;
  badge.classList.toggle('on', count > 0);
  window.omtAnnounce?.(
    count === 1 ? 'Prodotto aggiunto al carrello. 1 articolo.' : `Prodotto aggiunto al carrello. ${count} articoli.`
  );
});
